import { render, staticRenderFns } from "./HorseView.vue?vue&type=template&id=787435ef"
import script from "./HorseView.vue?vue&type=script&lang=js"
export * from "./HorseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports